export class PresentationContentOptions {
    constructor(public roundLogo?: boolean) {
    }
}
